// src/hooks/useCompliance.js
import { useCallback } from 'react';
import { calculateControlCompliance } from '../utils/complianceCalculator';

export const useCompliance = (getQuestionsForML) => {
  const calculateMaturityLevelCompliance = useCallback((controlName, ml, answers) => {
    if (ml === 'ML1') {
      return calculateControlCompliance(answers, getQuestionsForML(controlName, 'ML1'));
    } 
    
    if (ml === 'ML2') {
      const ml1Compliance = calculateControlCompliance(answers, getQuestionsForML(controlName, 'ML1'));
      return ml1Compliance === 100 ? 
        calculateControlCompliance(answers, getQuestionsForML(controlName, 'ML2')) : 0;
    } 
    
    if (ml === 'ML3') {
      const ml1Compliance = calculateControlCompliance(answers, getQuestionsForML(controlName, 'ML1'));
      const ml2Compliance = calculateControlCompliance(answers, getQuestionsForML(controlName, 'ML2'));
      return ml1Compliance === 100 && ml2Compliance === 100 ? 
        calculateControlCompliance(answers, getQuestionsForML(controlName, 'ML3')) : 0;
    }
    
    return 0;
  }, [getQuestionsForML]);

  return {
    calculateMaturityLevelCompliance
  };
};